import Button from '../Button/Button';
import React, { ReactNode } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Icon from '../Icon/Icon';

export interface ConfirmDialogPropsType {
    title?: ReactNode | string;
    content: ReactNode | string;
    customContent?: ReactNode;
    okText?: string;
    cancelText?: string;
    onOk?: () => void;
    onCancel: () => void;
    open: boolean;
    type?: ConfirmContentType;
    onClose?: () => void;
    showIcon?: boolean;
    closable?: boolean;
    customActions?: Array<ReactNode>;
}

export enum ConfirmContentType {
    INFO,
    WARNING,
    ERROR,
    SUCCESS,
}

const ConfirmDialog = ({
    title,
    content,
    customContent,
    open,
    onClose,
    onOk,
    onCancel,
    okText = 'OK',
    type = undefined,
    showIcon,
    cancelText = 'Abbrechen',
    closable = true,
    customActions,
}: ConfirmDialogPropsType) => {
    return (
        <div className={'relative'}>
            <Transition
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
            >
                <Dialog as={'div'} static={true} className={'fixed inset-0 z-50 flex justify-center items-center'} onClose={onClose || onCancel}>
                    <Dialog.Overlay
                        className={'fixed inset-0 bg-black opacity-40 flex;'}
                        onClick={
                            closable
                                ? () => onCancel()
                                : (e: any) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                  }
                        }
                    />
                    <div className={'z-50 bg-white shadow-xl rounded-md p-4 flex flex-col gap-4 max-w-lg w-full mx-2 sm:mx-auto sm:w-auto'}>
                        <div className={'flex flex-row w-full'}>
                            {showIcon && type === ConfirmContentType.WARNING && (
                                <div className={'pr-6 pl-2 text-center block'}>
                                    <Icon path={Icon.Path.mdiAlertOutline} className={'h-12  text-white bg-yellow-400 rounded-full p-2'} />
                                </div>
                            )}
                            {showIcon && type === ConfirmContentType.ERROR && (
                                <div className={'pr-6 pl-2 text-center block'}>
                                    <Icon path={Icon.Path.mdiAlertRhombusOutline} className={'h-12  text-white bg-red-600 rounded-full p-2'} />
                                </div>
                            )}
                            <div>
                                {title && <h2 className={'mb-2 '}>{title}</h2>}
                                <div className={'text-sm text-gray-400'}>{content}</div>
                            </div>
                        </div>
                        {customContent && (
                            <div className={'flex space-x-1'}>
                                <div className={'text-sm text-gray-400'}>{customContent}</div>
                            </div>
                        )}
                        <div className={'flex space-x-1'}>
                            {customActions?.length ? (
                                customActions
                            ) : (
                                <>
                                    <Button className={'flex-1 items-center whitespace-nowrap'} block={true} ghost={true} onClick={onCancel}>
                                        {cancelText}
                                    </Button>
                                    <Button className={'flex-1 items-center whitespace-nowrap'} block={true} primary={true} onClick={() => onOk?.()}>
                                        {okText}
                                    </Button>
                                </>
                            )}
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    );
};

export default ConfirmDialog;
